import React from 'react';

const PopSQLLogoMobile = ({ additionalStyles, className }) => {
  return (
    <figure
      className={`shadow-mobileLogo shadow-header bg-white h-20 w-20 flex items-center justify-center ${
        className || ''
      }`}
      style={{ borderRadius: '12px', ...additionalStyles }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80"
        height="80"
        fill="none"
        viewBox="0 0 80 80"
      >
        <g clipPath="url(#clip0_279_2841)">
          <path
            fill="url(#paint0_linear_279_2841)"
            fillRule="evenodd"
            d="M79.497 25.1c0-.937 0-1.875-.006-2.813-.004-.79-.013-1.58-.035-2.37-.046-1.721-.148-3.457-.454-5.16-.31-1.726-.817-3.333-1.616-4.902a16.485 16.485 0 00-7.213-7.21c-1.57-.798-3.18-1.305-4.908-1.615-1.702-.306-3.439-.407-5.16-.454-.79-.021-1.58-.03-2.371-.035-.938-.006-1.877-.005-2.815-.005L44.023.496h-8.15l-10.702.04c-.94 0-1.88 0-2.821.005-.792.005-1.584.014-2.376.035-1.725.047-3.465.148-5.171.454-1.731.31-3.342.817-4.915 1.616a16.53 16.53 0 00-7.227 7.209c-.802 1.57-1.31 3.177-1.62 4.905-.307 1.701-.409 3.437-.455 5.157-.022.79-.03 1.58-.036 2.37-.005.938-.054 2.103-.054 3.04V44.12l.05 10.78c0 .938-.001 1.877.004 2.817.005.79.014 1.582.036 2.373.046 1.723.148 3.462.455 5.166.31 1.729.819 3.338 1.62 4.909a16.514 16.514 0 007.226 7.22c1.574.8 3.186 1.307 4.918 1.618 1.705.306 3.445.407 5.17.454.791.021 1.583.03 2.375.035.94.006 1.88.005 2.82.005H54.92c.938 0 1.877 0 2.815-.005.79-.005 1.58-.014 2.371-.035 1.722-.047 3.459-.148 5.162-.455 1.727-.31 3.335-.818 4.905-1.617a16.492 16.492 0 007.213-7.22c.8-1.571 1.307-3.181 1.617-4.911.306-1.704.408-3.442.454-5.164.022-.791.03-1.582.035-2.373.006-.94.006-1.879.006-2.818V35.874 25.1"
            clipRule="evenodd"
          ></path>
          <g filter="url(#filter0_ddd_279_2841)">
            <path
              fill="url(#paint1_linear_279_2841)"
              fillRule="evenodd"
              d="M33.693 62.561c0 1.358-1.334 2.459-2.978 2.459h-.847c-1.644 0-2.977-1.1-2.977-2.459V42.206c0-1.357 1.333-2.458 2.977-2.458h.847c1.644 0 2.978 1.1 2.978 2.459V62.56z"
              clipRule="evenodd"
            ></path>
            <path
              fill="url(#paint2_linear_279_2841)"
              fillRule="evenodd"
              d="M32.576 62.339c0 1.353-1.285 2.45-2.87 2.45h-.817c-1.585 0-2.87-1.097-2.87-2.45V42.045c0-1.354 1.285-2.451 2.87-2.451h.816c1.586 0 2.871 1.097 2.871 2.451v20.294z"
              clipRule="evenodd"
            ></path>
            <g filter="url(#filter1_iii_279_2841)">
              <path
                fill="url(#paint3_linear_279_2841)"
                fillRule="evenodd"
                d="M33.48 56.274H24.9c-3.913 0-3.89-4.296-3.89-4.296v-31.81c0-5.052 3.77-4.61 3.77-4.61h23.631c13.768 0 13.177 11.064 13.177 11.064v8.137c0 14.59-12.197 14.495-12.197 14.495h-8.792v2.484c0 4.82-3.914 4.536-3.914 4.536H33.48z"
                clipRule="evenodd"
              ></path>
            </g>
          </g>
        </g>
        <defs>
          <filter
            id="filter0_ddd_279_2841"
            width="72.463"
            height="81.353"
            x="5.069"
            y="12.361"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              result="hardAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dy="0.848"></feOffset>
            <feGaussianBlur stdDeviation="0.53"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0161557 0"></feColorMatrix>
            <feBlend
              in2="BackgroundImageFix"
              result="effect1_dropShadow_279_2841"
            ></feBlend>
            <feColorMatrix
              in="SourceAlpha"
              result="hardAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dy="2.848"></feOffset>
            <feGaussianBlur stdDeviation="1.78"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0238443 0"></feColorMatrix>
            <feBlend
              in2="effect1_dropShadow_279_2841"
              result="effect2_dropShadow_279_2841"
            ></feBlend>
            <feColorMatrix
              in="SourceAlpha"
              result="hardAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dy="12.753"></feOffset>
            <feGaussianBlur stdDeviation="7.97"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"></feColorMatrix>
            <feBlend
              in2="effect2_dropShadow_279_2841"
              result="effect3_dropShadow_279_2841"
            ></feBlend>
            <feBlend
              in="SourceGraphic"
              in2="effect3_dropShadow_279_2841"
              result="shape"
            ></feBlend>
          </filter>
          <filter
            id="filter1_iii_279_2841"
            width="49.126"
            height="48.763"
            x="13.741"
            y="8.79"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feBlend
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            ></feBlend>
            <feColorMatrix
              in="SourceAlpha"
              result="hardAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="-9.565" dy="-2.933"></feOffset>
            <feGaussianBlur stdDeviation="3.635"></feGaussianBlur>
            <feComposite
              in2="hardAlpha"
              k2="-1"
              k3="1"
              operator="arithmetic"
            ></feComposite>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"></feColorMatrix>
            <feBlend
              in2="shape"
              result="effect1_innerShadow_279_2841"
            ></feBlend>
            <feColorMatrix
              in="SourceAlpha"
              result="hardAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="-8.799" dy="-10.075"></feOffset>
            <feGaussianBlur stdDeviation="3.379"></feGaussianBlur>
            <feComposite
              in2="hardAlpha"
              k2="-1"
              k3="1"
              operator="arithmetic"
            ></feComposite>
            <feColorMatrix values="0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"></feColorMatrix>
            <feBlend
              in2="effect1_innerShadow_279_2841"
              result="effect2_innerShadow_279_2841"
            ></feBlend>
            <feColorMatrix
              in="SourceAlpha"
              result="hardAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1.275" dy="1.275"></feOffset>
            <feGaussianBlur stdDeviation="1.913"></feGaussianBlur>
            <feComposite
              in2="hardAlpha"
              k2="-1"
              k3="1"
              operator="arithmetic"
            ></feComposite>
            <feColorMatrix values="0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"></feColorMatrix>
            <feBlend
              in2="effect2_innerShadow_279_2841"
              result="effect3_innerShadow_279_2841"
            ></feBlend>
          </filter>
          <linearGradient
            id="paint0_linear_279_2841"
            x1="39.997"
            x2="39.997"
            y1="0.497"
            y2="79.497"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FBFBFB"></stop>
            <stop offset="1" stopColor="#fff"></stop>
          </linearGradient>
          <linearGradient
            id="paint1_linear_279_2841"
            x1="30.275"
            x2="30.292"
            y1="57.197"
            y2="65.02"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#CDA181"></stop>
            <stop offset="0.651" stopColor="#CAB2A2"></stop>
            <stop offset="1" stopColor="#9A765B"></stop>
          </linearGradient>
          <linearGradient
            id="paint2_linear_279_2841"
            x1="32.597"
            x2="25.977"
            y1="59.376"
            y2="59.758"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F3D2BB"></stop>
            <stop offset="1" stopColor="#E0BDA3"></stop>
          </linearGradient>
          <linearGradient
            id="paint3_linear_279_2841"
            x1="23.96"
            x2="51.719"
            y1="19.78"
            y2="44.916"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFAE71"></stop>
            <stop offset="1" stopColor="#FF6C81"></stop>
          </linearGradient>
          <clipPath id="clip0_279_2841">
            <path fill="#fff" d="M0 0H80V80H0z"></path>
          </clipPath>
        </defs>
      </svg>
    </figure>
  );
};

export default PopSQLLogoMobile;
